import { createSlice  } from '@reduxjs/toolkit'

const initialState = {
    employeeList: {
      requesting: false,
      items: [],
      pagination: {
		  current_page: 1,
		  per_page: 10,
		  total: 0,
	  },
      error: null,
      success: false,
      filters: {},
    },
    employeeDetails: {
      requesting: false,
      error: null,
      success: false,
      data: null
    },
    //
    employeeScheduleList: {
      requesting: false,
      items: [],
      pagination: {
		  current_page: 1,
		  per_page: 10,
		  total: 0,
	  },
      error: null,
      success: false,
      filters: {},
    },
    employeeScheduleDetails: {
      requesting: false,
      error: null,
      success: false,
      data: null
    },
    //
    employeeSettingList: {
      requesting: false,
      items: [],
      error: null,
      success: false,
      filters: {},
    },
    employeeSettingDetails: {
      requesting: false,
      error: null,
      success: false,
      data: null
    },
  };

export const employeeSlice = createSlice({
  name: 'employee',
  initialState,
  reducers: {
    getEmployeeList: (state, action) => {		
      state.employeeList.requesting = true;
      state.employeeList.error = null;
      state.employeeList.items = [];
      state.employeeList.success = false;
      state.employeeList.filters = action.payload;
    },
    getEmployeeListSuccess: (state, action) => {
		  const { data, current_page, per_page, total} = action.payload;
      state.employeeList.requesting = false;        
      state.employeeList.items = data;
      state.employeeList.success = true; 
      state.employeeList.pagination.current_page = current_page;
      state.employeeList.pagination.per_page = per_page;
      state.employeeList.pagination.total = total;
    },
    getEmployeeListFail: (state, action) => {        
      state.employeeList.requesting = false;
      state.employeeList.error = action.payload;
    },
    getEmployeeDetails: (state) => {
      state.employeeDetails.requesting = true;
      state.employeeDetails.error = null;
      state.employeeDetails.data = null;
      state.employeeDetails.success = false; 
    },
    getEmployeeDetailsSuccess: (state, action) => {
      state.employeeDetails.requesting = false;
      state.employeeDetails.data = action.payload;
      state.employeeDetails.success = true; 
    },
    getEmployeeDetailsFail: (state, action) => {        
      state.employeeDetails.requesting = false;
      state.employeeDetails.error = action.payload;
    },
    doEmployeeCreate: (state) => {
      state.employeeDetails.requesting = true;
      state.employeeDetails.error = null;
      state.employeeDetails.data = null;
      state.employeeDetails.success = false; 
    },
    doEmployeeUpdate: (state) => {
      state.employeeDetails.requesting = true;
      state.employeeDetails.error = null;
      state.employeeDetails.data = null;
      state.employeeDetails.success = false; 
    },
    doEmployeeDelete: (state) => {
      state.employeeDetails.requesting = true;
      state.employeeDetails.error = null;
      state.employeeDetails.data = null;
      state.employeeDetails.success = false; 
    },
    // for schedule
    getEmployeeScheduleList: (state, action) => {		
      state.employeeScheduleList.requesting = true;
      state.employeeScheduleList.error = null;
      state.employeeScheduleList.items = [];
      state.employeeScheduleList.success = false;
      state.employeeScheduleList.filters = action.payload;
      state.employeeScheduleDetails.data = null;
    },
    getEmployeeScheduleListSuccess: (state, action) => {
		  const { data, current_page, per_page, total} = action.payload;
      state.employeeScheduleList.requesting = false;        
      state.employeeScheduleList.items = data;
      state.employeeScheduleList.success = true; 
      state.employeeScheduleList.pagination.current_page = current_page;
      state.employeeScheduleList.pagination.per_page = per_page;
      state.employeeScheduleList.pagination.total = total;
    },
    getEmployeeScheduleListFail: (state, action) => {        
      state.employeeScheduleList.requesting = false;
      state.employeeScheduleList.error = action.payload;
    },
    getEmployeeScheduleDetails: (state) => {
      state.employeeScheduleDetails.requesting = true;
      state.employeeScheduleDetails.error = null;
      state.employeeScheduleDetails.data = null;
      state.employeeScheduleDetails.success = false; 
    },
    getEmployeeScheduleDetailsSuccess: (state, action) => {
      state.employeeScheduleDetails.requesting = false;
      state.employeeScheduleDetails.data = action.payload;
      state.employeeScheduleDetails.success = true; 
    },
    getEmployeeScheduleDetailsFail: (state, action) => {        
      state.employeeScheduleDetails.requesting = false;
      state.employeeScheduleDetails.error = action.payload;
    },
    doEmployeeScheduleCreate: (state) => {
      state.employeeScheduleDetails.requesting = true;
      state.employeeScheduleDetails.error = null;
      state.employeeScheduleDetails.data = null;
      state.employeeScheduleDetails.success = false; 
    },
    doEmployeeScheduleUpdate: (state) => {
      state.employeeScheduleDetails.requesting = true;
      state.employeeScheduleDetails.error = null;
      state.employeeScheduleDetails.data = null;
      state.employeeScheduleDetails.success = false; 
    },
    doEmployeeScheduleDelete: (state) => {
      state.employeeScheduleDetails.requesting = true;
      state.employeeScheduleDetails.error = null;
      state.employeeScheduleDetails.data = null;
      state.employeeScheduleDetails.success = false; 
    },
    doEmployeeScheduleReset: (state) => {		
      state.employeeScheduleDetails.data = null;
    },
    // for setting
    getEmployeeSettingList: (state, action) => {		
      state.employeeSettingList.requesting = true;
      state.employeeSettingList.error = null;
      state.employeeSettingList.items = [];
      state.employeeSettingList.success = false;
      state.employeeSettingList.filters = action.payload;
      state.employeeSettingDetails.data = null;
    },
    getEmployeeSettingListSuccess: (state, action) => {
      state.employeeSettingList.requesting = false;        
      state.employeeSettingList.items = action.payload;
      state.employeeSettingList.success = true; 
    },
    getEmployeeSettingListFail: (state, action) => {        
      state.employeeSettingList.requesting = false;
      state.employeeSettingList.error = action.payload;
    },
    getEmployeeSettingDetails: (state) => {
      state.employeeSettingDetails.requesting = true;
      state.employeeSettingDetails.error = null;
      state.employeeSettingDetails.data = null;
      state.employeeSettingDetails.success = false; 
    },
    getEmployeeSettingDetailsSuccess: (state, action) => {
      state.employeeSettingDetails.requesting = false;
      state.employeeSettingDetails.data = action.payload;
      state.employeeSettingDetails.success = true; 
    },
    getEmployeeSettingDetailsFail: (state, action) => {        
      state.employeeSettingDetails.requesting = false;
      state.employeeSettingDetails.error = action.payload;
    },
    doEmployeeSettingUpdate: (state) => {
      state.employeeSettingDetails.requesting = true;
      state.employeeSettingDetails.error = null;
      state.employeeSettingDetails.data = null;
      state.employeeSettingDetails.success = false; 
    },
  },
})

export const { 
    getEmployeeList, getEmployeeListSuccess, getEmployeeListFail,
    getEmployeeDetails, getEmployeeDetailsSuccess, getEmployeeDetailsFail,
    doEmployeeCreate, doEmployeeUpdate, doEmployeeDelete,
    getEmployeeCOEDetails, getEmployeeCOEDetailsSuccess, getEmployeeCOEDetailsFail,
    getEmployeeScheduleList, getEmployeeScheduleListSuccess, getEmployeeScheduleListFail,
    getEmployeeScheduleDetails, getEmployeeScheduleDetailsSuccess, getEmployeeScheduleDetailsFail,
    doEmployeeScheduleCreate, doEmployeeScheduleUpdate, doEmployeeScheduleDelete,
    doEmployeeScheduleReset,
    getEmployeeSettingList, getEmployeeSettingListSuccess, getEmployeeSettingListFail,
    getEmployeeSettingDetails, getEmployeeSettingDetailsSuccess, getEmployeeSettingDetailsFail,
    doEmployeeSettingUpdate
} = employeeSlice.actions

export default employeeSlice.reducer